import React from "react";
import Sidebar from "../../Sidebar/Sidebar";
import "./UserDetails.css";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import leftArrow from "../../../../assests/leftArrow.svg";
import profile from "../../../../assests/gprofile.svg";
import Avatar from "../../../../assests/Avatar.png";
import uid from "../../../../assests/uid.svg";
import phone1 from "../../../../assests/phone11.svg";
import warehouse from "../../../../assests/warehouse.svg";
import mail from "../../../../assests/mail.svg";
import cohorts from "../../../../assests/cohorts.svg";
import watch from "../../../../assests/watch.svg";
import calander from "../../../../assests/calander.svg";
import { Link, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";
import verifiedIcon from "../../../../assests/verifiedIcon.svg";
import notverifiedIcon from "../../../../assests/notverifiedIcon.svg";
import employeeCode from "../../../../assests/employeeCode.svg";
import moment from "moment";
import { useParams } from "react-router-dom";

const UserDetailsComp = ({ data, loading }) => {
  const { userid } = useParams();
  const navigate = useNavigate();

  const handleBack = () => navigate("/home/users/list");

  // Function to construct correct image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath || imagePath === "null" || imagePath === "undefined") {
      return null;
    }
    
    // Remove any query parameters if present
    const cleanPath = imagePath.split('?')[0];
    
    // Check if the path already contains the full URL
    if (cleanPath.startsWith('http')) {
      return cleanPath;
    }
    
    // Remove "product/" prefix if it exists (to avoid duplication)
    const pathWithoutProductPrefix = cleanPath.startsWith('product/') 
      ? cleanPath.substring('product/'.length) 
      : cleanPath;
    
    // Encode the filename to handle special characters
    const encodedPath = encodeURIComponent(pathWithoutProductPrefix);
    
    // Construct the correct S3 URL with product/public prefix
    return `https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/product/${pathWithoutProductPrefix}`;
  };

  // Get the image URL
  const imageUrl = data?.userDetails?.imageUrl ? getImageUrl(data.userDetails.imageUrl) : null;

  return (
    <div className="user-details-container">
      <Sidebar />
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="user-details-content">
          <div className="users-details-header">
            <div className="header-title-container">
              <button className="back-button" onClick={handleBack}>
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>User Details</h1>
            </div>
          </div>

          <div className="information-container">
            {data?.userDetails && (
              <div className="basic-info-section">
                <div className="section-header">
                  <h2>
                    <img src={profile} alt="Profile" /> Basic Information
                  </h2>
                  <Button className="edit-button">
                    <Link to={`/updateuserdetails/${userid}`}>Edit</Link>
                  </Button>
                </div>

                <div className="background-container">
                  <div className="user-info-container">
                    <div className="user-profile-card">
                      <div className="user-designation">
                        <div className="user-image-container">
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={data.userDetails.full_name || "User"}
                              className="user-main-image"
                              onError={(e) => {
                                console.error("Image failed to load, showing fallback avatar");
                                e.target.style.display = "none";
                                e.target.nextSibling.style.display = "flex";
                              }}
                              style={{height:"100px", width:"100px", borderRadius:"10px"}}
                              loading="lazy"
                            />
                          ) : null}
                          <div
                            className="user-image-placeholder"
                            style={{ display: imageUrl ? "none" : "flex" }}
                          >
                            <img 
                              className="user-avatar" 
                              src={Avatar} 
                              alt="User Avatar"
                              loading="lazy"
                            />
                          </div>
                        </div>
                        
                        <div className="user-info">
                          <h3>{data.userDetails.full_name}</h3>
                          <span>{data.userRole?.role_name}</span>
                          <div className="verification-status">
                            {data.userDetails.verificationStatus === "verified" ? (
                              <>
                                <img src={verifiedIcon} alt="Verified" />
                                <span className="verified-text">Verified</span>
                              </>
                            ) : (
                              <>
                                <img src={notverifiedIcon} alt="Not Verified" />
                                <span className="not-verified-text">Not Verified</span>
                              </>
                            )}
                          </div>
                        </div>
                        <div className={`status-badge ${data.userDetails.status}`}>
                          <p>{data.userDetails.status}</p>
                        </div>
                      </div>
                    </div>

                    <div className="user-details-card">
                      <ul className="details-list">
                        <li className="detail-item">
                          <img src={uid} alt="User ID" />
                          <p>User ID: {data.userDetails.id}</p>
                        </li>
                        <li className="detail-item">
                          <img src={employeeCode} alt="Employee Code" />
                          <p>Employee Code: {data.userDetails.employeeCode || "N/A"}</p>
                        </li>
                        <li className="detail-item">
                          <img src={phone1} alt="Phone" />
                          <p>{data.userDetails.mobile}</p>
                        </li>
                        <li className="detail-item">
                          <img src={mail} alt="Email" />
                          <p>{data.userDetails.email}</p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="login-info-container">
                    <ul className="login-details">
                      <li className="login-item">
                        <img src={watch} alt="Since" />
                        <p>
                          Member since: <br />
                          <strong>
                            {moment.utc(data.userDetails.since)
                              .local()
                              .format("DD/MM/YYYY HH:mm A")}
                          </strong>
                        </p>
                      </li>
                      <li className="login-item">
                        <img src={calander} alt="Last Login" />
                        <p>
                          Last login: <br />
                          <strong>
                            {moment.utc(data.userDetails.last_login)
                              .local()
                              .format("DD/MM/YYYY HH:mm A")}
                          </strong>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {data?.warehouse && (
              <div className="warehouse-section">
                <div className="section-header">
                  <h2>
                    <img src={warehouse} alt="Warehouse" /> Warehouse
                  </h2>
                  <Button className="edit-button">
                    <Link to={`/updatewarehouse/${userid}`}>Edit</Link>
                  </Button>
                </div>
                <div className="warehouse-content">
                  <p className="warehouse-description">
                    The user is added in the below warehouse
                  </p>
                  <div className="warehouse-details">
                    <h3>{data.warehouse.name}</h3>
                    <p>{data.warehouse.id}</p>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="cohorts-section">
            <div className="section-header">
              <h2>
                <img src={cohorts} alt="Cohorts" /> Cohorts
              </h2>
              <Button className="edit-button">
                <Link to={`/updatecohortdetails/${userid}`}>Edit</Link>
              </Button>
            </div>

            <div className="cohorts-content">
              <p className="cohorts-description">
                The user is added in the below cohorts
              </p>
              <div className="table-responsive">
                <Table hover responsive className="cohorts-table">
                  <thead>
                    <tr>
                      <th>Cohort ID</th>
                      <th>Cohort Name</th>
                      <th>Area Name</th>
                      <th>Cohort Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.cohorts?.length > 0 ? (
                      data.cohorts.map((item) => (
                        <tr key={item.id}>
                          <td>{item.id}</td>
                          <td>{item.name}</td>
                          <td>{item.area_name}</td>
                          <td>
                            <div className="cohort-type-badge">
                              <p>{item.cohort_type_name}</p>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="no-cohorts">
                          No cohorts assigned
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserDetailsComp;